import React, { Component } from "react";
import { connect } from "react-redux";
import CenteredPaper from "../layouts/CenteredPaper";
import { IrqTitle } from "../molecules/IrqTitle";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import { withNavigationContext } from "../util/withNavigationContext";
import ILearn from "../molecules/ILearn";
import { CreditScoreInput } from "../atoms/CreditScoreInput";
import EditActions from "../schema/misc/EditActions";

class IrqCreditScoreView extends Component {
  render() {
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle
            content={this.props.content}
            icon="/img/svg_icons/credit_score.svg"
          />
          <div className="credit-score-content-wrapper">
            <CreditScoreInput
              name="creditScore"
              error={!!this.props.errors.creditScore}
              helperText={this.props.errors.creditScore}
              placeholder="e.g. 700"
              value={this.props.data.creditScore || ""}
              onChange={this.props.onFormEdit}
              onBlur={this.props.onBlur}
            />
          </div>
          <EditActions
            canSubmit={this.props.isValid}
            customSubmit={() =>
              this.props.navigationContext.goNext(
                this.props.data.occupancyType === "Primary"
                  ? this.props.navigationsAway.Primary
                  : this.props.navigationsAway.Secondary
              )
            }
          />
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(
  withNavigationContext(connect()(IrqCreditScoreView))
);
